var a
var i = 0
function myLoop3(a) {
    setTimeout(function () {
        if ($(a[a.length - i]).hasClass('pad') || $(a[a.length - i]).hasClass('flex')) {
            console.log('tiene clase')
            $(a[a.length - i]).width('100%')
        }
        else {
            $(a[a.length - i]).width($(a[a.length - i]).width() * 2.23)
        }
        $(a[a.length - i]).height($(a[a.length - i]).height() * 2.23)
        if ($(a[a.length - i]).css("fontSize")) {
            console.log($(a[a.length - i]).css("fontSize"))
            $(a[a.length - i]).css("font-size", parseInt($(a[a.length - i]).css("fontSize").replace('px', '')) * 2.23 + 'px');
        }
        $(a[a.length - i]).css('max-width', '4000px')
        $(a[a.length - i]).css('max-height', '4000px')
        i++;
        if (i <= a.length) {
            myLoop3(a);
        }
        else {
            $('.pad').width('auto')
            $('.inv-link-grid').width('auto')
            $('main').append($('#inv'))
            $('#invitaciones-section').addClass('d-none')
            $('#inv').width('100%')
            $('.normal-par').width('auto')
            $('.cont').width('auto')
            $('a').width('auto')
            $('#invtitle-0').width('auto')
            $('#invname1-0').width('auto')
            $('#invname2-0').width('auto')
            $('#invname3-0').width('auto')
            $('#invname4-0').width('auto')
            $('#invsuperior-0').width('auto')
            $('.fullCont').width('100%')
            $('.two-col').width('auto')
            $('#inv').css('z-index', '999999')
            $('#invfooterTitle-0').width('auto')
        }
    }, 10)
}
$(document).ready(async function () {
    let url_string = window.location.href;
    let url = new URL(url_string);
    let allowedParams = ['section', 'invitacion', "customer"];
    let params = url.searchParams;
    let borro = false
    for (var [key, value] of params.entries()) {
        if (!allowedParams.includes(key)) {
            borro = true
            params.delete(key);
        }
    }
    if (borro) {
        let newURL = url.origin + url.pathname + '?' + params.toString();
        window.location.href = newURL;
    }
    let page = url.searchParams.get("page");
    page = parseInt(page)
    var section = url.searchParams.get("section");
    var invitation = url.searchParams.get("invitacion");
    var preview = url.searchParams.get("preview");
    if (invitation) {
        $('#invitation-0').removeClass('d-none')
        const eventElement = document.querySelector('.eventElement')
        const select3 = document.getElementById("font-selector-3")
        const select4 = document.getElementById("font-selector-4")
        if (eventElement) {
            eventElement.classList.remove('d-none');
        }
        if (currentInvitationDesignData) {
            $('#font-selector-3').val(currentInvitationDesignData.tipografia_principal)
            $('#font-selector-4').val(currentInvitationDesignData.tipografia_de_apoyo)
            console.log('Va a aplicar el diseño')
            const eventElements = document.querySelectorAll('[id^="invEvent-"]');
            eventElements.forEach((element) => {
                element.classList.remove('d-none');
            });
            // if (currentInvitationDesignData.tipografia_principal && select3) {
            //     let apiUrl
            //     let url
            //     let fontStyle
            //     apiUrl = [];
            //     apiUrl.push('https://fonts.googleapis.com/css?family=')
            //     apiUrl.push(select3.value.replace(/ /g, '+'))
            //     console.log('apiUrl', apiUrl)
            //     url = apiUrl.join('')
            //     fontStyle = `h1, h2, h3, h4, h5, h6, .hero-par, .big-par {font-family: '${currentInvitationDesignData.tipografia_principal}', sans-serif !important;}`
            //     if (!document.getElementById("googleFont")) {
            //         let headLink = document.createElement('link')
            //         headLink.rel = "stylesheet"
            //         headLink.href = url
            //         headLink.id = "googleFont"
            //         document.head.appendChild(headLink)
            //     } else {
            //         let currentHeadLink = document.getElementById("googleFont")
            //         currentHeadLink.href = url
            //     }
            //     if (!document.getElementById("customStyle")) {
            //         let headStyle = document.createElement("style")
            //         headStyle.innerText = fontStyle
            //         headStyle.id = "customStyle"
            //         document.head.appendChild(headStyle)
            //     } else {
            //         let customStyle = document.getElementById("customStyle")
            //         console.log(customStyle)
            //         customStyle.innerHTML = fontStyle
            //     }
            // }
            // if (currentInvitationDesignData.tipografia_de_apoyo && select4) {
            //     console.log('passs currentInvitationDesignData && select4 validation')
            //     apiUrl = [];
            //     apiUrl.push('https://fonts.googleapis.com/css?family=')
            //     apiUrl.push(select4.value.replace(/ /g, '+'))
            //     url = apiUrl.join('')
            //     fontStyle = `div, a {font-family: '${currentInvitationDesignData.tipografia_de_apoyo}', sans-serif !important;}`
            //     if (!document.getElementById("googleFont2")) {
            //         headLink = document.createElement('link')
            //         headLink.rel = "stylesheet"
            //         headLink.href = url
            //         headLink.id = "googleFont2"
            //         document.head.appendChild(headLink)
            //     } else {
            //         currentHeadLink = document.getElementById("googleFont2")
            //         currentHeadLink.href = url
            //     }
            //     if (!document.getElementById("customStyle2")) {
            //         headStyle = document.createElement("style")
            //         headStyle.innerText = fontStyle
            //         headStyle.id = "customStyle2"
            //         document.head.appendChild(headStyle)
            //     } else {
            //         customStyle = document.getElementById("customStyle2")
            //         console.log(customStyle)
            //         customStyle.innerHTML = fontStyle
            //     }
            // }
        }
        $('#wedsiteStyles').remove()
        setTimeout(function () {
            $('#wedsiteFooter').addClass('d-none')
            $('#wedsiteContent').addClass('d-none')
            $('#dd-home').addClass('d-none')
            $('#customize_button').addClass('d-none')
            $('.mesa-page-title').addClass('d-none')
            $('#default-1').addClass('d-none')
            $('#default-2').addClass('d-none')
            $('#default-3').addClass('d-none')
            $('#default-4').addClass('d-none')
            $('#inv-customize').removeClass('d-none')
            $('#MainNavBar').addClass('d-none')
        }, 100);
        if (invitation == 'edit') {
            //$('#invitation-0').removeClass('d-none')
            $('#inv_customize_button').removeClass('d-none')
            $('#back_button_invitations').removeClass('d-none')
            $('#backBtn2').addClass('d-none')
            $('#back_button_default').addClass('d-none')
        }
        if (invitation == '1') {
            console.log('passs invitation = 1')
            // if (preview == '1') {
            //     console.log('passs preview = 1')
            //     $('#backBtn2').removeClass('d-none')
            //     $('#back_button').addClass('d-none')
            // }
            // else {
            //     console.log('else preview = 1')
            //     $('#back_button').removeClass('d-none')
            //     $('#back_button').attr('href', '/pages/invitaciones')
            //     $('#backBtn2').addClass('d-none')
            // }
            var pdf = url.searchParams.get("pdf");
            //$('#invitation-0').removeClass('d-none')
            $('.eventElement').removeClass('d-none')
            $('#back_button_invitations').removeClass('d-none')
            $('#backBtn2').removeClass('d-none')
            $('#invBoletosQty').text('2')
            if (pdf == 'true') {
                $('#back_button').addClass('d-none')
                $('#back_button_default').addClass('d-none')
                $('#back_button_invitations').addClass('d-none')
                $('#backBtn2').addClass('d-none')
                $('#invitaciones-section').css('position', 'relative')
                $('#invitaciones-section').css('z-index', '99999999')
                a = $('#inv *')
                a.each(function () {
                    $(this).css('max-width', $(this).outerWidth())
                    $(this).css('max-height', $(this).outerHeight())
                })
                console.log(a)
                console.log('Aquí llama a la función')
                await myLoop3(a)
                $('.pad.big-pad').css('padding-bottom', '0')
            }
        }
        console.log(invitation != 'edit' && invitation != 1)
        if (invitation != 'edit' && invitation != 1) {
            $('#back_button').addClass('d-none')
            $('#back_button_default').addClass('d-none')
            $('#back_button_invitations').addClass('d-none')
            $('#back_button_invitations').attr('href', '/pages/invitaciones')
            $('#backBtn2').addClass('d-none')
            const url = new URL(window.location.href);
            let cId = url.searchParams.get("customer");
            cId = cId.replace('#', '')
            const invBtnUrl = $('#invbtn-0').attr('href').replace('CustomRSVP', 'RSVP') + '&customer=' + cId
            $('#invbtn-0').attr('href', invBtnUrl)
            $('.inv-wrap').each(function () {
                console.log($(this).attr('objectid'))
                if ($(this).attr('objectid').replaceAll('"', '') == "gid://shopify/Metaobject/" + invitation) {
                    $(this).removeClass('d-none')
                }
            })
        }
        if (isAdmin) {
            $('#back_button_invitations').attr('href', '/account?Dashboard=1&section=Invitaciones')
            $('#back_button_invitations').text('Ir a Dashboard')
        } else {
            $('#back_button_invitations').addClass('d-none')
        }

    } else {
        // const select1 = document.getElementById("font-selector")
        // const select2 = document.getElementById("font-selector-2")
        // if (currentDesignData.tipografia_principal) {
        //     $('#font-selector').val(currentDesignData.tipografia_principal)
        // }
        // if (currentDesignData.tipografia_de_apoyo) {
        //     $('#font-selector-2').val(currentDesignData.tipografia_de_apoyo)
        // }
        // let apiUrl = []
        // let url
        // let fontStyle
        // if (currentDesignData.tipografia_principal && select1) {
        //     apiUrl.push('https://fonts.googleapis.com/css?family=')
        //     apiUrl.push(select1.value.replace(/ /g, '+'))
        //     url = apiUrl.join('')
        //     fontStyle = `h1, h2, h3, h4, h5, h6 {font-family: '${select1.value}', sans-serif !important;}`
        //     if (!document.getElementById("googleFont")) {
        //         let headLink = document.createElement('link')
        //         headLink.rel = "stylesheet"
        //         headLink.href = url
        //         headLink.id = "googleFont"
        //         document.head.appendChild(headLink)
        //     } else {
        //         let currentHeadLink = document.getElementById("googleFont")
        //         currentHeadLink.href = url
        //     }
        //     if (!document.getElementById("customStyle")) {
        //         let headStyle = document.createElement("style")
        //         headStyle.innerText = fontStyle
        //         headStyle.id = "customStyle"
        //         document.head.appendChild(headStyle)
        //     } else {
        //         let customStyle = document.getElementById("customStyle")
        //         console.log(customStyle)
        //         customStyle.innerHTML = fontStyle
        //     }
        // }
        // if (currentDesignData.tipografia_de_apoyo && select2) {
        //     apiUrl = [];
        //     apiUrl.push('https://fonts.googleapis.com/css?family=')
        //     apiUrl.push(select2.value.replace(/ /g, '+'))
        //     url = apiUrl.join('')
        //     fontStyle = `div, a {font-family: '${select2.value}', sans-serif !important;}`
        //     if (!document.getElementById("googleFont2")) {
        //         headLink = document.createElement('link')
        //         headLink.rel = "stylesheet"
        //         headLink.href = url
        //         headLink.id = "googleFont2"
        //         document.head.appendChild(headLink)
        //     } else {
        //         currentHeadLink = document.getElementById("googleFont2")
        //         currentHeadLink.href = url
        //     }
        //     if (!document.getElementById("customStyle2")) {
        //         headStyle = document.createElement("style")
        //         headStyle.innerText = fontStyle
        //         headStyle.id = "customStyle2"
        //         document.head.appendChild(headStyle)
        //     } else {
        //         customStyle = document.getElementById("customStyle2")
        //         console.log(customStyle)
        //         customStyle.innerHTML = fontStyle
        //     }
        // }
        $('#back_button').removeClass('d-none')
        $('#backBtn2').addClass('d-none')
        $('#inv-styles').remove()
        $('#invitationStyles').remove()
    }
    if (section != '' && section != null && section != undefined) {
        if (section === 'CustomRSVP') {
            section = 'RSVP'
        }
        setTimeout(function () {
            document.getElementById(section).click()
        }, 100);
    }
    else {
        if (page > 0) {
            setTimeout(function () {
                document.getElementById('Mesa').click()
            }, 100);
        }
    }
    ColMetafields(currentCollectionPage)
})
function restarHorasAFecha(fecha, horasARestar) {
    let fechaObj = new Date(fecha); // Convertir la cadena de fecha a un objeto Date
    fechaObj.setHours(fechaObj.getHours() - horasARestar); // Restar las horas
    return fechaObj.toISOString(); // Retorna la nueva fecha en formato ISO
}

async function ColMetafields(value) {
    var products = null
    var metafields = await getCollectionMetafield(value)
    for (const met of metafields) {
        if (met.key == "productos") {
            products = JSON.parse(met.value)
        }
    }
    if (products[0] != null) {
        for (prod of products) {
            var id
            var have
            id = ('' + prod.id).replace('gid://shopify/Product/', '')
            $('#have_' + id).text(prod.recibidos)
            have = prod.recibidos
            if (prod.recibidos < prod.cuantos) {
                $('#regalar_' + id).removeClass('d-none')
                $('#qtyData_' + id).removeClass('d-none')
            }
            else {
                $('#qtyData_' + id).removeClass('d-none')
                $('#regalado_' + id).removeClass('d-none')
            }
            if (prod.cuantos == null || prod.cuantos == undefined || prod.cuantos == '' || prod.cuantos < 1) {
                $('#qtyData_' + id).addClass('d-none')
            }
            $('#want_' + id).text(prod.cuantos)
            $('#qty_' + id).attr('max', prod.cuantos - have)
        }
    }
    else {
        $('.qty-data').addClass('d-none')
    }
}